<template>
  <el-dialog
    title="查看"
    :close-on-click-modal="false"
    :visible.sync="modal"
    class="question-modal"
  >
    <el-descriptions :column="1">
      <el-descriptions-item label="题型">{{
        questionDetail.questionType
      }}</el-descriptions-item>
      <el-descriptions-item label="题干">
        <div v-html="questionDetail.questionStem"></div
      ></el-descriptions-item>
      <el-descriptions-item label="选项">
        <div v-for="(item, index) in questionDetail.list" :key="index">
          {{ item.answerFLag }}.{{ item.answerStem }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="答案">
        {{ questionDetail.questionAnswer }}
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>
<script>
import { getQuestionBankDetail } from "@/api/manage";
export default {
  data() {
    return {
      modal: false,
      questionDetail: {
        questionStem: null,
        questionType: null,
        questionAnswer: null,
        list: null
      }
    };
  },
  methods: {
    async getInfo(id) {
      const res = await getQuestionBankDetail(id);

      if (res.data.code === 200) {
        this.modal = true;
        this.questionDetail.questionStem = res.data.data.questionStem;
        this.questionDetail.questionType =
          res.data.data.questionType == "1"
            ? "单选题"
            : res.data.data.questionType == "3"
            ? "多选题"
            : res.data.data.questionType == "2"
            ? "判断题"
            : "";
        this.questionDetail.questionAnswer = res.data.data.questionAnswer;
        this.questionDetail.list = res.data.data.list;
      }
    },
    async open(id) {
      this.modal = true;
      await this.getInfo(id);
    }
  }
};
</script>
<style lang="less" scoped>
.question-modal {
  /deep/ .el-descriptions-item__content {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Bank/TheoryBank/TheoryBankDetail.vue